import { useApp } from '../../context/AppContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';

export const FrequencySelector = ({ type = 'compounding' }) => {
  const { inputs, updateInput, t } = useApp();
  
  const isCompounding = type === 'compounding';
  const currentValue = isCompounding ? inputs.compoundingFrequency : inputs.contributionFrequency;
  const inputKey = isCompounding ? 'compoundingFrequency' : 'contributionFrequency';
  const label = isCompounding ? t('compoundingFrequency') : t('contributionFrequency');
  
  const options = [
    { value: 12, label: t('monthly') },
    { value: 4, label: t('quarterly') },
    { value: 2, label: t('semiannually') },
    { value: 1, label: t('annually') },
  ];
  
  return (
    <div className="space-y-2" data-testid={`${type}-frequency-selector`}>
      <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium">
        {label}
      </Label>
      <Select
        value={currentValue.toString()}
        onValueChange={(value) => updateInput(inputKey, parseInt(value))}
      >
        <SelectTrigger 
          className="w-full h-10 bg-background border focus:ring-2 focus:ring-blue-500/50"
          data-testid={`${type}-frequency-trigger`}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-popover border shadow-xl">
          {options.map((option) => (
            <SelectItem 
              key={option.value} 
              value={option.value.toString()}
              className="cursor-pointer"
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default FrequencySelector;
